import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationNewUser.vue";

export const selector = (item: Notification): boolean => {
  return [NotificationType.MEMBER_APPROVED, NotificationType.CREATOR_APPROVED].includes(item.type);
};
